@if (meta()?.author) {
  <app-context-menu [options]="{ width: '300px', noSpacing: true, openOnHover: !meta().author }" position="center">
    <!-- Context Button -->
    <div contextButton class="author-info">
      @if (meta().author) {
        <app-picture [url]="meta().author.image.filename | storyblokCdn" [width]="48" [height]="48"></app-picture>
        <div class="meta-info">
          <div class="author-name">{{ meta().author.name.split(' ')[0] }}</div>
        </div>
      }
    </div>

    <!-- Context Content -->
    <div contextContent class="author-context">
      <div class="author-top">
        <app-picture [url]="meta().author.image.filename | storyblokCdn" [width]="64" [height]="64"></app-picture>
        <div class="spacer"></div>
        @if (meta().author.xLink) {
          <a
            appButton
            name="x-link"
            location="blog-meta"
            [iconButton]="true"
            color="simple"
            shape="round"
            [href]="meta().author.xLink"
            target="_blank"
          >
            <app-svg src="/assets/icons/logo/twitter.svg"></app-svg>
          </a>
        }
        @if (meta().author.instaLink) {
          <a
            appButton
            name="instagram-link"
            location="blog-meta"
            [iconButton]="true"
            color="simple"
            shape="round"
            [href]="meta().author.instaLink"
            target="_blank"
          >
            <app-svg src="/assets/icons/logo/instagram.svg"></app-svg>
          </a>
        }
      </div>
      <div class="author-bottom">
        <div class="author-name">{{ meta().author.name }}</div>
        <div class="author-role">{{ meta().author.role }}</div>
      </div>
    </div>
  </app-context-menu>
  <div class="dot"></div>
}

@if (meta()) {
  <app-context-menu
    [options]="{ width: '300px', noSpacing: true, openOnHover: !meta().author }"
    position="center"
    [disabled]="meta().published === meta().updated"
  >
    <div contextButton class="published-date">
      @if (meta().updated) {
        <time itemprop="dateModified" [attr.content]="meta().updated | date: 'yyyy-MM-dd'">
          Updated on {{ meta().updated | date: 'MMMM dd, yyyy' }}
        </time>
      } @else if (meta().published) {
        <time itemprop="publishedDate" [attr.content]="meta().published | date: 'yyyy-MM-dd'">
          Published on {{ meta().published | date: 'MMMM dd, yyyy' }}
        </time>
      } @else {
        <time> Not published yet </time>
      }
    </div>
    <div contextContent class="published-date-context">
      <time itemprop="publishedDate" [attr.content]="meta().published | date: 'yyyy-MM-dd'">
        Published on {{ meta().published | date: 'MMMM dd, yyyy' }}
      </time>
      <time itemprop="dateModified" [attr.content]="meta().updated | date: 'yyyy-MM-dd'">
        Updated on {{ meta().updated | date: 'MMMM dd, yyyy' }}
      </time>
    </div>
  </app-context-menu>
  <div class="dot"></div>
}

@if (storyLength() !== undefined) {
  <time itemprop="timeRequired" [attr.content]="'PT' + storyLength() + 'M'" class="story-length">
    {{ storyLength() }} min read
  </time>
}
